//recipeId, orgamizationId
import { struct } from 'io-ts/Decoder';

import { Id as RecipeId } from '../../../../whole-house/recipe/Id';

export const Params = struct({
	recipeId: RecipeId,
});
